<template>
  <div class="layout">
    <app-header></app-header>
    <transition name="fade">
      <router-view class="main"></router-view>
    </transition>
    <app-side-tool></app-side-tool>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppHeader from './app-header'
import AppSideTool from './app-side-tool'
import AppFooter from './app-footer'

export default {
  name: 'app-layout',
  components: {
    AppHeader,
    AppSideTool,
    AppFooter
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.main {
  padding-top: 60px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to,
.fade-slow-enter,
.fade-slow-leave-to {
  opacity: 0;
}

.fade-slow-enter-active,
.fade-slow-leave-active {
  transition: opacity 1.5s;
}
</style>



// WEBPACK FOOTER //
// src/components/app-layout.vue